export enum Runtime {
    Node145 = 'node-14.5',
    Node160 = 'node-16.0',
    Node180 = 'node-18.0',
    Node190 = 'node-19.0',
    Node200 = 'node-20.0',
    Node210 = 'node-21.0',
    Node22 = 'node-22',
    Php80 = 'php-8.0',
    Php81 = 'php-8.1',
    Php82 = 'php-8.2',
    Php83 = 'php-8.3',
    Ruby30 = 'ruby-3.0',
    Ruby31 = 'ruby-3.1',
    Ruby32 = 'ruby-3.2',
    Ruby33 = 'ruby-3.3',
    Python38 = 'python-3.8',
    Python39 = 'python-3.9',
    Python310 = 'python-3.10',
    Python311 = 'python-3.11',
    Python312 = 'python-3.12',
    Pythonml311 = 'python-ml-3.11',
    Pythonml312 = 'python-ml-3.12',
    Deno121 = 'deno-1.21',
    Deno124 = 'deno-1.24',
    Deno135 = 'deno-1.35',
    Deno140 = 'deno-1.40',
    Deno146 = 'deno-1.46',
    Deno20 = 'deno-2.0',
    Dart215 = 'dart-2.15',
    Dart216 = 'dart-2.16',
    Dart217 = 'dart-2.17',
    Dart218 = 'dart-2.18',
    Dart219 = 'dart-2.19',
    Dart30 = 'dart-3.0',
    Dart31 = 'dart-3.1',
    Dart33 = 'dart-3.3',
    Dart35 = 'dart-3.5',
    Dotnet60 = 'dotnet-6.0',
    Dotnet70 = 'dotnet-7.0',
    Dotnet80 = 'dotnet-8.0',
    Java80 = 'java-8.0',
    Java110 = 'java-11.0',
    Java170 = 'java-17.0',
    Java180 = 'java-18.0',
    Java210 = 'java-21.0',
    Java22 = 'java-22',
    Swift55 = 'swift-5.5',
    Swift58 = 'swift-5.8',
    Swift59 = 'swift-5.9',
    Swift510 = 'swift-5.10',
    Kotlin16 = 'kotlin-1.6',
    Kotlin18 = 'kotlin-1.8',
    Kotlin19 = 'kotlin-1.9',
    Kotlin20 = 'kotlin-2.0',
    Cpp17 = 'cpp-17',
    Cpp20 = 'cpp-20',
    Bun10 = 'bun-1.0',
    Bun11 = 'bun-1.1',
    Go123 = 'go-1.23',
    Static1 = 'static-1',
    Flutter324 = 'flutter-3.24',
    Flutter327 = 'flutter-3.27',
    Flutter329 = 'flutter-3.29',
}